import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import ricky from '../../assets/images/speakers/ricky.png'; // use the exact file name you have

function Ricky() {
  return (
    <>
      <div className="header">
        <div className="header-content">
          <div className="left">
            <div className="header-box">
              <h1 className="title">
                Q<sup>3</sup> Initiative: QEthics @ USC
              </h1>
            </div>
            <p>September 12, 2025 - September 13, 2025</p>
            <p>University of Southern California</p>
            <p>TBD</p>
          </div>
          <div className="right">
            <img src={logo} className="logo" alt="Q^3 Logo" />
          </div>
        </div>
      </div>

      <div className="speaker-box">
        <div className="speaker-photo">
          <img src={ricky} alt="Ricky Young" className="speakerspic" />
        </div>
        <div className="speaker-content">
          <h1>Ricky Young</h1>
          <h2>COO, qBraid</h2>
        </div>
      </div>

      <div className="speaker-content">
        <p className="p">
          Ricky Young is the COO of qBraid, a startup with over 21,000 users worldwide accessing
          over 24+ quantum devices directly through qBraid or via the cloud with Amazon Braket and
          Microsoft Azure Quantum. He is actively involved in various workforce development
          activities in quantum computing including hackathons, and regional projects around the
          world.
        </p>
      </div>
    </>
  );
}

export default Ricky;
